import { find } from 'lodash';
import Config from '../../config';
import { CURRENCIES } from '../../constants';

export function toCurrency(priceStr, currencyCode) {
  let config = new Config().getConfig();
  const currencyCodeToMatch = currencyCode || config.currencyCode;
  const currency = find(CURRENCIES, _ => _.code === currencyCodeToMatch);

  const formattedPrice = parseFloat(priceStr, 10).toFixed(2);

  return currency ? `${currency.symbol}${formattedPrice}` : formattedPrice;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/displayHelpers.js